/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseImportJobView } from '../../models/api-response-import-job-view';
import { ImportRowEdits } from '../../models/import-row-edits';

export interface EditImportRows$Params {
  'x-api-requestId'?: string;
  reference: string;
      body: ImportRowEdits
}

export function editImportRows(http: HttpClient, rootUrl: string, params: EditImportRows$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportJobView>> {
  const rb = new RequestBuilder(rootUrl, editImportRows.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseImportJobView>;
    })
  );
}

editImportRows.PATH = '/v1/api/ui/imports/{reference}/rows/edit';
